import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import Footer from "../../components/Footer";
import PatientLoginMain from "./PatientLoginMain";

const PatientLogin = () => {
  return (
    <>
      <HeaderFour headerClass="it-header-area-two" />
      <PatientLoginMain />
      <Footer />
    </>
  );
};

export default PatientLogin;
